import { post } from 'helpers/requests';
import { API, BASE_URL } from '../../CONST';
import { SET_ACCIONES_PERMITIDAS } from '../constants/action-types';

export const fetchAccionesPermitidas = (organizationId, policyNemotecnico = null) => (dispatch) => {
  const url = `${BASE_URL}${API.accionesPermitidas}/get_user_actions/`;
  
  const body = {
    organization_id: organizationId
  };
  
  if (policyNemotecnico) {
    body.policy_nemotecnico = policyNemotecnico;
  }
  
  return post(url, body)
    .then((response) => {
      dispatch({
        type: SET_ACCIONES_PERMITIDAS,
        payload: response
      });
      return response;
    })
    .catch((error) => {
      console.error('Error fetching acciones permitidas:', error);
      dispatch({
        type: SET_ACCIONES_PERMITIDAS,
        payload: null
      });
      throw error; // Re-throw so calling code can handle it
    });
};